(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pet-calculator"] && !Shopify.designMode) return;
  try {
    
  window.__PET_CAT_BREEDS = window.__PET_CAT_BREEDS || [
    'Abyssinian','Aegean','American Bobtail','American Curl','American Shorthair','American Wirehair','Angora','Aphrodite Giant','Arabian Mau','Asian','Australian Mist','Balinese','Bengal cat','Birman','Bombay cat','Brazilian Shorthair','British Longhair','British Shorthair','Burmese','Burmilla','California Spangled','Chantilly-Tiffany','Chinchilla','Chartreux','Chausie','Colorpoint Shorthair','Cornish Rex','Cymric','Devon Rex','Donskoy (Don Sphynx)','Dragon Li','Egyptian Mau','European Shorthair','Exotic Shorthair','Foreign white','German Rex','Havana Brown','Himalayan','Japanese Bobtail','Javanese','Khao Manee','Korat','Kurilian Bobtail','LaPerm','Lykoi','Maine Coon','Manx','Mekong Bobtail','Minskin','Munchkin','Nebelung','Norwegian Forest Cat','Ocicat','Ojos Azules','Oriental Longhair','Oriental Shorthair','Persian','Peterbald','Pixie-bob','Ragamuffin','Ragdoll','Russian Blue','Savannah','Scottish Fold','Selkirk Rex','Serengeti','Siamese','Siberian','Singapura','Snowshoe','Sokoke','Somali','Sphynx','Suphalak','Tabby','Thai','Tonkinese','Toyger','Turkish Angora','Turkish Van','Ukrainian Levkoy','York Chocolate'
  ];
  window.__PET_DOG_BREEDS = window.__PET_DOG_BREEDS || [
    'Afador','Affenhuahua','Affenpinscher','Afghan Hound','Airedale Terrier','Akbash','Akita','Akita Chow','Akita Pit','Akita Shepherd','Alaskan Klee Kai','Alaskan Malamute','American Bulldog','American English Coonhound','American Eskimo Dog','American Foxhound','American Hairless Terrier','American Leopard Hound','American Pit Bull Terrier','American Pugabull','American Staffordshire Terrier','American Water Spaniel','Anatolian Shepherd Dog','Appenzeller Sennenhunde','Auggie','Aussiedoodle','Aussiepom','Australian Cattle Dog','Australian Kelpie','Australian Retriever','Australian Shepherd','Australian Shepherd Husky','Australian Shepherd Lab Mix','Australian Shepherd Pit Bull Mix','Australian Stumpy Tail Cattle Dog','Australian Terrier','Azawakh','Barbet','Basenji','Bassador','Basset Fauve de Bretagne','Basset Hound','Basset Retriever','Bavarian Mountain Scent Hound','Beabull','Beagle','Beaglier','Bearded Collie','Bedlington Terrier','Belgian Malinois','Belgian Sheepdog','Belgian Tervuren','Bergamasco Sheepdog','Berger Picard','Bernedoodle','Bernese Mountain Dog','Bichon Frise','Biewer Terrier','Black and Tan Coonhound','Black Mouth Cur','Black Russian Terrier','Bloodhound','Blue Lacy','Bluetick Coonhound','Bocker','Boerboel','Boglen Terrier','Bohemian Shepherd','Bolognese','Borador','Border Collie','Border Sheepdog','Border Terrier','Bordoodle','Borzoi','BoShih','Bossie','Boston Boxer','Boston Terrier','Boston Terrier Pekingese Mix','Bouvier des Flandres','Boxador','Boxer','Boxerdoodle','Boxmatian','Boxweiler','Boykin Spaniel','Bracco Italiano','Braque du Bourbonnais','Briard','Brittany','Broholmer','Brussels Griffon','Bugg','Bull-Pei','Bull Terrier','Bullador','Bullboxer Pit','Bulldog','Bullmastiff','Bullmatian','Cairn Terrier','Canaan Dog','Cane Corso','Cardigan Welsh Corgi','Carolina Dog','Catahoula Bulldog','Catahoula Leopard Dog','Caucasian Shepherd Dog','Cav-a-Jack','Cavachon','Cavador','Cavalier King Charles Spaniel','Cavapoo','Central Asian Shepherd Dog','Cesky Terrier','Chabrador','Cheagle','Chesapeake Bay Retriever','Chi Chi','Chi-Poo','Chigi','Chihuahua','Chilier','Chinese Crested','Chinese Shar-Pei','Chinook','Chion','Chipin','Chiweenie','Chorkie','Chow Chow','Chow Shepherd','Chug','Chusky','Cirneco dell Etna','Clumber Spaniel','Cockalier','Cockapoo','Cocker Spaniel','Collie','Corgi Inu','Corgidor','Corman Shepherd','Coton de Tulear','Croatian Sheepdog','Curly-Coated Retriever','Dachsador','Dachshund','Dalmatian','Dandie Dinmont Terrier','Daniff','Deutscher Wachtelhund','Doberdor','Doberman Pinscher','Docker','Dogo Argentino','Dogue de Bordeaux','Dorgi','Dorkie','Doxiepoo','Doxle','Drentsche Patrijshond','Drever','Dutch Shepherd','English Cocker Spaniel','English Foxhound','English Setter','English Springer Spaniel','English Toy Spaniel','Entlebucher Mountain Dog','Estrela Mountain Dog','Eurasier','Field Spaniel','Fila Brasileiro','Finnish Lapphund','Finnish Spitz','Flat-Coated Retriever','Fox Terrier','French Bulldog','French Bullhuahua','French Spaniel','Frenchton','Frengle','German Longhaired Pointer','German Pinscher','German Shepherd Dog','German Shepherd Pit Bull','German Shepherd Rottweiler Mix','German Sheprador','German Shorthaired Pointer','German Spitz','German Wirehaired Pointer','Giant Schnauzer','Glen of Imaal Terrier','Goberian','Goldador','Golden Cocker Retriever','Golden Mountain Dog','Golden Retriever','Golden Retriever Corgi','Golden Shepherd','Goldendoodle','Gollie','Gordon Setter','Great Dane','Great Pyrenees','Greater Swiss Mountain Dog','Greyador','Greyhound','Hamiltonstovare','Hanoverian Scenthound','Harrier','Havanese','Hokkaido','Horgi','Huskita','Huskydoodle','Ibizan Hound','Icelandic Sheepdog','Irish Red and White Setter','Irish Setter','Irish Terrier','Irish Water Spaniel','Irish Wolfhound','Italian Greyhound','Jack-A-Poo','Jack Chi','Jack Russell Terrier','Jackshund','Japanese Chin','Japanese Spitz','Korean Jindo Dog','Karelian Bear Dog','Keeshond','Kerry Blue Terrier','King Shepherd','Komondor','Kooikerhondje','Kuvasz','Kyi-Leo','Lab Pointer','Labernese','Labmaraner','Labrabull','Labradane','Labradoodle','Labrador Retriever','Labrastaff','Labsky','Lagotto Romagnolo','Lakeland Terrier','Lancashire Heeler','Leonberger','Lhasa Apso','Lhasapoo','Lowchen','Maltese','Maltese Shih Tzu','Maltipoo','Manchester Terrier','Mastador','Mastiff','Miniature Pinscher','Miniature Schnauzer','Morkie','Mudi','Mutt','Neapolitan Mastiff','Newfoundland','Norfolk Terrier','Norwegian Buhund','Norwegian Elkhound','Norwegian Lundehund','Norwich Terrier','Nova Scotia Duck Tolling Retriever','Old English Sheepdog','Otterhound','Papillon','Papipoo','Peekapoo','Pekingese','Pembroke Welsh Corgi','Petit Basset Griffon Vendeen','Pharaoh Hound','Pitsky','Plott','Pocket Beagle','Pointer','Polish Lowland Sheepdog','Pomapoo','Pomchi','Pomeagle','Pomeranian','Pomsky','Poochon','Poodle','Portuguese Podengo Pequeno','Portuguese Water Dog','Pug','Pugalier','Puggle','Puginese','Puli','Pyredoodle','Pyrenean Shepherd','Rat Terrier','Redbone Coonhound','Rhodesian Ridgeback','Rottador','Rottle','Rottweiler','Saint Berdoodle','Saint Bernard','Saluki','Samoyed','Samusky','Schipperke','Schnoodle','Scottish Deerhound','Scottish Terrier','Sealyham Terrier','Sheepadoodle','Shepsky','Shetland Sheepdog','Shiba Inu','Shichon','Shih-Poo','Shih Tzu','Shiloh Shepherd','Shiranian','Shollie','Shorkie','Siberian Husky','Silken Windhound','Silky Terrier','Skye Terrier','Sloughi','Small Munsterlander Pointer','Soft Coated Wheaten Terrier','Spanish Mastiff','Spinone Italiano','Springador','Stabyhoun','Staffordshire Bull Terrier','Standard Schnauzer','Sussex Spaniel','Swedish Vallhund','Terripoo','Texas Heeler','Tibetan Mastiff','Tibetan Spaniel','Tibetan Terrier','Toy Fox Terrier','Treeing Tennessee Brindle','Treeing Walker Coonhound','Valley Bulldog','Vizsla','Weimaraner','Welsh Springer Spaniel','Welsh Terrier','West Highland White Terrier','Westiepoo','Whippet','Whoodle','Wirehaired Pointing Griffon','Xoloitzcuintli','Yorkipoo','Yorkshire Terrier'
  ];

  function scoreStatus(score) {
    if (score <= 3) return { label: 'Needs Attention', cls: 'score-tag score-low', note: 'Possible digestive issue. Consider diet adjustment or consult a vet.' };
    if (score <= 6) return { label: 'Monitor Closely', cls: 'score-tag score-mid', note: 'Minor changes observed. Adjust feeding and observe.' };
    return { label: 'Healthy Digestion', cls: 'score-tag score-good', note: 'Everything looks good. Keep current feeding routine.' };
  }

  function updateGauge(id, score, statusLabel) {
    const needle = document.getElementById('gauge-needle-' + id);
    const value = document.getElementById('gauge-value-' + id);
    const text = document.getElementById('gauge-text-' + id);
    if (!needle || !value || !text) return;
    const normalized = Math.max(0, Math.min(8, score));
    const tenScale = (normalized / 8) * 10;
    const angle = (tenScale / 10) * 180 - 90;
    needle.style.transform = 'translateX(-50%) rotate(' + angle + 'deg)';
    value.innerText = normalized.toFixed(0) + ' / 8';
    text.innerText = 'Gut health score is ' + normalized.toFixed(0) + '/8 (' + statusLabel + ').';
  }

  function populateBreeds(id, species, forceReset) {
    const root = document.getElementById('pet-cat-report-' + id);
    const breedEl = document.getElementById('breed-' + id);
    if (!breedEl) return;
    const current = breedEl.value;
    const list = species === 'dog' ? window.__PET_DOG_BREEDS : window.__PET_CAT_BREEDS;
    const defaultBreed = species === 'dog'
      ? ((root && root.dataset.defaultBreedDog) || 'Labrador Retriever')
      : ((root && root.dataset.defaultBreedCat) || 'Domestic Shorthair');

    let normalizedList = list.slice();
    if (normalizedList.indexOf(defaultBreed) < 0) {
      normalizedList.unshift(defaultBreed);
    }

    breedEl.innerHTML = '<option value="" disabled selected hidden>Select breed</option>' + normalizedList.map(function(b) {
      return '<option value="' + b.replace(/"/g, '&quot;') + '">' + b + '</option>';
    }).join('');
    if (forceReset) {
      breedEl.value = '';
      return;
    }
    if (normalizedList.indexOf(current) >= 0) {
      breedEl.value = current;
    } else {
      breedEl.value = '';
    }
  }

  function updateHeroImage(id) {
    const root = document.getElementById('pet-cat-report-' + id);
    const imageEl = document.getElementById('hero-image-' + id);
    if (!root || !imageEl) return;
    const species = document.getElementById('species-' + id).value;
    imageEl.src = species === 'dog' ? (root.dataset.dogImage || imageEl.src) : (root.dataset.catImage || imageEl.src);
    imageEl.alt = species === 'dog' ? 'Dog header image' : 'Cat header image';
  }

  function applySpeciesDefaults(id, forceReset) {
    const root = document.getElementById('pet-cat-report-' + id);
    if (!root) return;
    const species = document.getElementById('species-' + id).value;
    const nameInput = document.getElementById('name-' + id);
    const weightInput = document.getElementById('weight-' + id);

    if (forceReset || !nameInput.value.trim()) {
      nameInput.value = species === 'dog' ? (root.dataset.defaultNameDog || 'Buddy') : (root.dataset.defaultNameCat || 'Luna');
    }
    weightInput.placeholder = species === 'dog' ? 'e.g. 18.5' : 'e.g. 4.2';
    const conditionEl = document.getElementById('condition-' + id);
    const reportModeEl = document.getElementById('report-mode-' + id);
    const maintenanceEl = document.getElementById('stage-' + id);
    if (conditionEl) {
      conditionEl.innerHTML = species === 'dog'
        ? '<option value="normal">Normal</option><option value="active">Active dog</option><option value="pregnant">Pregnant / Lactating</option>'
        : '<option value="normal">Normal</option><option value="active">Active cat</option><option value="pregnant">Pregnant / Lactating</option>';
    }
    if (reportModeEl) {
      reportModeEl.innerHTML = species === 'dog'
        ? '<option value="full">Complete Dog Wellness Report</option><option value="water">Hydrate Right: Dog Water Calculator</option><option value="feed">Dog Feeding Guidance Report</option><option value="gut">Gut Health Calculator for Dogs</option>'
        : '<option value="full">Complete Cat Wellness Report</option><option value="water">Hydrate Right: Cat Water Calculator</option><option value="feed">Cat Feeding Guidance Report</option><option value="gut">Gut Health Calculator for Cats</option>';
    }
    if (maintenanceEl) {
      maintenanceEl.innerHTML = species === 'dog'
        ? '<option value="3.0">Puppy - 0 to 4 months</option><option value="2.0">Puppy - 4 months to adult</option><option value="1.2">Dog - inactive or obese prone</option><option value="1.6" selected>Dog (neutered/spayed) - average activity</option><option value="1.8">Dog (intact) - average activity</option><option value="1.0">Dog - weight loss needed</option><option value="1.7">Dog - weight gain needed</option><option value="2.0">Working dog - light work</option><option value="3.0">Working dog - moderate work</option><option value="5.0">Working dog - heavy work</option><option value="3.0">Pregnancy week-5</option><option value="4.0">Lactation 3-4 pups</option><option value="5.0">Lactation 5-6 pups</option><option value="5.5">Lactation 7-8 pups</option><option value="6.0">Lactation 9 or more</option><option value="1.1">Senior</option>'
        : '<option value="2.5">Kitten - 0 to 4 months</option><option value="2.0">Kitten - 4 months to adult</option><option value="1.1">Cat - low activity / indoor</option><option value="1.2" selected>Cat (neutered/spayed) - average activity</option><option value="1.4">Cat (intact) - average activity</option><option value="1.0">Cat - weight loss needed</option><option value="1.4">Cat - weight gain needed</option><option value="3.0">Pregnancy</option><option value="4.0">Lactation</option><option value="1.0">Senior</option>';
    }

    populateBreeds(id, species, forceReset);
    updateHeroImage(id);
    applyReportMode(id);
  }

  function applyReportMode(id) {
    const mode = document.getElementById('report-mode-' + id).value;
    const fullMode = mode === 'full';
    const waterMode = mode === 'water';
    const feedMode = mode === 'feed';
    const gutMode = mode === 'gut';

    const setVisible = function(selector, visible) {
      document.querySelectorAll(selector).forEach(function(el) {
        el.style.display = visible ? 'block' : 'none';
      });
    };

    setVisible('#pet-cat-report-' + id + ' .input-water', fullMode || waterMode);
    setVisible('#pet-cat-report-' + id + ' .input-core', true);
    setVisible('#pet-cat-report-' + id + ' .input-gut', fullMode || gutMode);
    setVisible('#pet-cat-report-' + id + ' .input-health', fullMode);
    setVisible('#pet-cat-report-' + id + ' .input-feed', fullMode || feedMode);
    setVisible('#pet-cat-report-' + id + ' .input-health-feed', fullMode || feedMode);
    setVisible('#pet-cat-report-' + id + ' .input-legacy', false);

    const show = function(el, yes, displayValue) {
      if (el) el.style.display = yes ? (displayValue || 'block') : 'none';
    };
    const statHealth = document.getElementById('stat-health-' + id);
    const statWater = document.getElementById('stat-water-' + id);
    const statFeed = document.getElementById('stat-feed-' + id);
    const statCalories = document.getElementById('stat-calories-' + id);
    const speedoCard = document.getElementById('speedo-card-' + id);
    const cardHealth = document.getElementById('report-card-health-' + id);
    const cardWater = document.getElementById('report-card-water-' + id);
    const cardFeed = document.getElementById('report-card-feed-' + id);
    const cardGut = document.getElementById('report-card-gut-' + id);
    const schedTable = document.getElementById('sched-table-' + id);
    const generateBtn = document.getElementById('generate-btn-' + id);

    show(statHealth, fullMode || gutMode);
    show(statWater, fullMode || waterMode);
    show(statFeed, fullMode || feedMode);
    show(statCalories, fullMode || feedMode);
    show(speedoCard, fullMode || gutMode);
    show(cardHealth, fullMode);
    show(cardWater, fullMode || waterMode);
    show(cardFeed, fullMode || feedMode);
    show(cardGut, fullMode || gutMode);
    show(schedTable, fullMode || waterMode || feedMode || gutMode, 'table');

    if (generateBtn) {
      if (mode === 'full') generateBtn.innerText = 'Generate Complete Wellness Report';
      if (mode === 'water') generateBtn.innerText = 'Generate Water Intake Tracker';
      if (mode === 'feed') generateBtn.innerText = 'Generate Feeding Guidance Report';
      if (mode === 'gut') generateBtn.innerText = 'Generate Gut Health Check';
    }
  }

  function calculateWater(weight, species, condition) {
    const base = species === 'dog' ? 60 : 50;
    let factor = 1;
    if (condition === 'active') factor = species === 'dog' ? 1.2 : 1.1;
    if (condition === 'pregnant') factor = 1.5;
    return Math.round(weight * base * factor);
  }

  function printReport(id) {
    const results = document.getElementById('results-' + id);
    if (!results || results.style.display === 'none') {
      alert('Please generate a report first.');
      return;
    }
    const win = window.open('', '_blank');
    if (!win) return;
    win.document.write('<html><head><title>Pet Report</title><style>body{font-family:Arial,sans-serif;padding:20px;color:#111}.summary-pill,.stat-card,.report-card,.sched-table{margin-bottom:14px}.stat-card,.report-card{border:1px solid #ddd;padding:10px;border-radius:10px}.sched-table{width:100%;border-collapse:collapse}.sched-table th,.sched-table td{border:1px solid #ddd;padding:8px;text-align:left}</style></head><body>' + results.innerHTML + '</body></html>');
    win.document.close();
    win.focus();
    win.print();
    win.close();
  }

  function generatePetReport(id) {
    const root = document.getElementById('pet-cat-report-' + id);
    if (!root) return;

    const mode = document.getElementById('report-mode-' + id).value;
    const species = document.getElementById('species-' + id).value;
    const speciesTitle = species === 'dog' ? 'Dog' : 'Cat';
    const name = document.getElementById('name-' + id).value.trim();
    const breed = document.getElementById('breed-' + id).value;
    const weight = parseFloat(document.getElementById('weight-' + id).value);
    const condition = document.getElementById('condition-' + id).value;
    const stool = parseInt(document.getElementById('stool-' + id).value, 10);
    const appetite = parseInt(document.getElementById('appetite-' + id).value, 10);
    const energy = parseInt(document.getElementById('energy-' + id).value, 10);
    const hydration = parseInt(document.getElementById('hydration-' + id).value, 10);
    const stage = document.getElementById('stage-' + id).value;
    const bcs = parseInt(document.getElementById('bcs-' + id).value, 10);
    const maintenanceFactor = parseFloat(document.getElementById('stage-' + id).value);
    const productEnergyPer100g = parseFloat(document.getElementById('product-energy-' + id).value);

    const fullMode = mode === 'full';
    const waterMode = mode === 'water';
    const feedMode = mode === 'feed';
    const gutMode = mode === 'gut';
    const missing = [];

    if (!name) missing.push('Pet Name');
    if (!breed) missing.push('Breed');
    if (!weight || weight <= 0) missing.push('Body Weight');
    if ((fullMode || waterMode) && !condition) missing.push('Condition');
    if ((fullMode || gutMode) && (isNaN(stool) || isNaN(appetite) || isNaN(energy) || isNaN(hydration))) {
      missing.push('Gut Health Parameters');
    }
    if ((fullMode || feedMode) && !stage) missing.push('Life Stage');
    if ((fullMode || feedMode) && isNaN(maintenanceFactor)) missing.push('Maintenance Level');
    if ((fullMode || feedMode) && isNaN(bcs)) missing.push('BCS');
    if ((fullMode || feedMode) && isNaN(productEnergyPer100g)) missing.push('Product Category');

    if (missing.length) {
      alert('Please fill: ' + missing.join(', ') + '.');
      return;
    }

    const waterRequirement = (fullMode || waterMode) ? calculateWater(weight, species, condition) : 0;
    const gutScore = (fullMode || gutMode) ? (stool + appetite + energy + hydration) : 0;
    const gutStatus = scoreStatus(gutScore);
    const idealBodyWeight = (weight * 100) / (100 + ((bcs - 5) * 10));
    const metabolicBodyWeight = Math.pow(Math.max(0.1, idealBodyWeight), 0.75);
    const dailyCalories = Math.round(metabolicBodyWeight * 70 * maintenanceFactor);
    const recommendedFeed = (fullMode || feedMode) ? Math.round((dailyCalories * 100) / productEnergyPer100g) : 0;
    const bcsScore = Math.max(0, 10 - Math.abs(5 - bcs) * 1.5);
    const gutScoreOut10 = (gutScore / 8) * 10;
    const healthScore = Math.max(0, Math.min(10, Math.round(((0.6 * bcsScore) + (0.4 * gutScoreOut10)) * 10) / 10));

    document.getElementById('out-name-' + id).innerText = name || (species === 'dog' ? (root.dataset.defaultNameDog || 'Buddy') : (root.dataset.defaultNameCat || 'Luna'));
    document.getElementById('out-breed-' + id).innerText = breed || '-';
    document.getElementById('out-health-' + id).innerText = (fullMode || gutMode) ? (fullMode ? healthScore.toFixed(1) + '/10' : gutScore + '/8') : '-';
    document.getElementById('out-water-' + id).innerText = (fullMode || waterMode) ? (waterRequirement.toLocaleString() + ' ml') : '-';
    document.getElementById('out-feed-' + id).innerText = (fullMode || feedMode) ? (recommendedFeed.toLocaleString() + ' g') : '-';
    document.getElementById('out-cals-' + id).innerText = (fullMode || feedMode) ? (dailyCalories.toLocaleString() + ' kcal') : '-';

    const tagEl = document.getElementById('out-health-tag-' + id);
    tagEl.className = (fullMode || gutMode) ? gutStatus.cls : 'score-tag';
    tagEl.innerText = (fullMode || gutMode) ? gutStatus.label : 'Status';
    updateGauge(id, fullMode ? Math.round((healthScore / 10) * 8) : gutScore, gutStatus.label);

    document.getElementById('pet-health-text-' + id).innerText = (fullMode || gutMode)
      ? ('Health score: ' + healthScore.toFixed(1) + '/10. Gut score: ' + gutScore + '/8. ' + gutStatus.note)
      : 'Gut health details are not requested in this report mode.';

    document.getElementById('water-text-' + id).innerText = (fullMode || waterMode)
      ? ('Water Requirement in ml: ' + waterRequirement + ' ml/day for a ' + speciesTitle.toLowerCase() + ' with condition "' + condition + '".')
      : 'Water requirement details are not requested in this report mode.';

    document.getElementById('feed-text-' + id).innerText = (fullMode || feedMode)
      ? ('Estimated Ideal Body Weight: ' + idealBodyWeight.toFixed(2) + ' kg. Daily calories: ' + dailyCalories + ' kcal. Feed quantity: ' + recommendedFeed + ' g/day (based on ' + productEnergyPer100g + ' kcal per 100g).')
      : 'Feed details are not requested in this report mode.';

    document.getElementById('gut-text-' + id).innerText = (fullMode || gutMode)
      ? ('Stool: ' + stool + '/2, Appetite: ' + appetite + '/2, Energy: ' + energy + '/2, Hydration: ' + hydration + '/2. Result: ' + gutStatus.label + '.')
      : 'Gut parameter details are not requested in this report mode.';

    const thead = document.querySelector('#sched-table-' + id + ' thead');
    const tbody = document.getElementById('sched-body-' + id);
    const finalResultWrap = document.getElementById('final-result-' + id);
    const finalResultText = document.getElementById('final-result-text-' + id);
    if (fullMode || waterMode) {
      const waterMorning = Math.round(waterRequirement * 0.4);
      const waterEvening = Math.round(waterRequirement * 0.35);
      const waterNight = waterRequirement - waterMorning - waterEvening;
      thead.innerHTML = '<tr><th>Water Requirement in ml</th><th>Morning</th><th>Evening</th></tr>';
      tbody.innerHTML = '<tr><td>' + condition + '</td><td>' + waterMorning + ' ml</td><td>' + (waterEvening + waterNight) + ' ml</td></tr>';
      if (finalResultWrap && finalResultText) {
        finalResultWrap.style.display = 'block';
        finalResultText.innerText = 'Water plan generated';
      }
    } else if (feedMode) {
      thead.innerHTML = '<tr><th>Feed Planning</th><th>Morning</th><th>Evening</th></tr>';
      const feedMorning = Math.round(recommendedFeed * 0.4);
      const feedEvening = Math.round(recommendedFeed * 0.4);
      const feedNight = recommendedFeed - feedMorning - feedEvening;
      tbody.innerHTML = '<tr><td>Feed (g/day)</td><td>' + feedMorning + ' g</td><td>' + (feedEvening + feedNight) + ' g</td></tr>';
      if (finalResultWrap && finalResultText) {
        finalResultWrap.style.display = 'block';
        finalResultText.innerText = 'Feed plan generated';
      }
    } else {
      thead.innerHTML = '<tr><th>Gut Parameter</th><th>Selection Score</th><th>Max Score</th></tr>';
      tbody.innerHTML = '<tr><td>Stool Quality</td><td>' + stool + '</td><td>2</td></tr><tr><td>Appetite</td><td>' + appetite + '</td><td>2</td></tr><tr><td>Energy Level</td><td>' + energy + '</td><td>2</td></tr><tr><td>Hydration</td><td>' + hydration + '</td><td>2</td></tr>';
      if (finalResultWrap && finalResultText) {
        finalResultWrap.style.display = 'block';
        finalResultText.innerText = gutStatus.label;
      }
    }

    document.getElementById('results-' + id).style.display = 'block';
    document.getElementById('print-btn-' + id).style.display = 'inline-block';
    applyReportMode(id);
    window.scrollTo({ top: document.getElementById('results-' + id).offsetTop - 20, behavior: 'smooth' });
  }

  function initPetReportSections() {
    const wrappers = document.querySelectorAll('[id^="pet-cat-report-"]');
    wrappers.forEach(function(wrapper) {
      const id = wrapper.id.replace('pet-cat-report-', '');
      if (wrapper.dataset.petBound === '1') {
        return;
      }
      wrapper.dataset.petBound = '1';

      const speciesEl = document.getElementById('species-' + id);
      const modeEl = document.getElementById('report-mode-' + id);
      const generateBtn = document.getElementById('generate-btn-' + id);
      const printBtn = document.getElementById('print-btn-' + id);

      if (speciesEl) {
        speciesEl.addEventListener('change', function() {
          applySpeciesDefaults(id, true);
        });
      }
      if (modeEl) {
        modeEl.addEventListener('change', function() {
          applyReportMode(id);
        });
      }
      if (generateBtn) {
        generateBtn.addEventListener('click', function() {
          generatePetReport(id);
        });
      }
      if (printBtn) {
        printBtn.addEventListener('click', function() {
          printReport(id);
        });
      }

      applySpeciesDefaults(id, true);
      applyReportMode(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPetReportSections);
  } else {
    initPetReportSections();
  }

  document.addEventListener('shopify:section:load', initPetReportSections);

  // Fallback for Shopify preview/async renders: event delegation + timed retries.
  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t || !t.id) return;
    if (t.id.indexOf('species-') === 0) {
      const id = t.id.replace('species-', '');
      applySpeciesDefaults(id, true);
      applyReportMode(id);
      return;
    }
    if (t.id.indexOf('report-mode-') === 0) {
      const id = t.id.replace('report-mode-', '');
      applyReportMode(id);
    }
  });

  document.addEventListener('click', function(e) {
    const t = e.target;
    if (!t || !t.id) return;
    if (t.id.indexOf('generate-btn-') === 0) {
      const id = t.id.replace('generate-btn-', '');
      generatePetReport(id);
      return;
    }
    if (t.id.indexOf('print-btn-') === 0) {
      const id = t.id.replace('print-btn-', '');
      printReport(id);
    }
  });

  let retryCount = 0;
  const retryTimer = setInterval(function() {
    initPetReportSections();
    retryCount += 1;
    if (retryCount >= 20) {
      clearInterval(retryTimer);
    }
  }, 500);

  } catch(e) { console.error(e); }
})();
})();
